export class StorageEnum {
  static CT_TOKEN = 'ct-token';
  static CT_REFRESH_TOKEN = 'ct-refresh-token';
  static CT_RATE_VIDEO = 'ct-rate-video';
  static CT_IS_PUBLIC = 'ct-is-public';
  static CT_PUBLIC_USER_ID = 'ct-public-user-id';
  static KC_TOKEN = 'kc-token';
  static KC_REFRESH_TOKEN = 'kc-refresh-token';
}
